// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import AdminPortalStateType from "enums/AdminPortalStateType";
import Company, { processCompany } from "./Company";
import LicenseType from "enums/LicenseType";
import RoleType from "enums/RoleType";
import User, { processUser } from "./User";

export default interface AdminPortal {
    entityId?: string;
    state?: AdminPortalStateType;
    role?: RoleType;
    license?: LicenseType;
    admin?: boolean;
    adminUser?: User;
    company?: Company;
    seats?: number;
    pendingInvites?: number;
    seatsAvailable?: number;
    membersJoined?: number;
    cancelled?: boolean;
}

export function processAdminPortal(value?: AdminPortal): void {
  if (value) {
    processUser(value.adminUser);
    processCompany(value.company);
  }
}
